import { cn } from '@/lib/utils';

interface RtlIconProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Wraps a directional icon and mirrors it horizontally in RTL layouts.
 * Use this for icons like ChevronLeft, ChevronRight, ArrowLeft, ArrowRight.
 */
export function RtlIcon({ children, className }: RtlIconProps) {
  return <span className={cn('inline-flex rtl:scale-x-[-1]', className)}>{children}</span>;
}
